import { BaseUrl } from "./AdditionalApi";

export const PostUrlAdvertisement = `${BaseUrl}/api/findmates/`;


export default PostUrlAdvertisement;
